import React from "react";
import { compose } from 'react-apollo';
import { injectIntl } from "react-intl";
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Field, formValueSelector } from 'redux-form';
import { connect } from "react-redux";
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';

import { change } from 'redux-form';

import InputFieldComponent from "../Common/FormField/InputFieldComponent";
import SelectFieldComponent from "../Common/FormField/SelectFieldComponent";
import CountryList from "../CountryList/CountryList";
import PhoneVerificationModal from "../PhoneVerificationModal/PhoneVerificationModal";
import ProfileUpload from "../../helpers/EditProfileInfo/profileUpload";

import messages from "../../locale/messages";
import PopulateData from '../../helpers/populateData';
import { getSpecificConfig } from "../../helpers/getConfigValue";

import s from './CommonFields.css';
import bt from '../../components/commonStyle.css';

class CommonFields extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dateOfBirthData: {},
            countryCode: 'US',
            country: '+1',
            maxUploadSize: ''
        }
    }

    componentDidMount() {
        const { initialValues } = this.props;
        const { country, countryCode } = this.state;
        if (initialValues && initialValues?.countryCode) {
            this.setState({
                countryCode: initialValues?.countryName ? initialValues?.countryName : countryCode,
                country: initialValues?.countryCode ? initialValues?.countryCode : country
            });
        }
        this.handleMaxUploadFile();
    }

    UNSAFE_componentWillMount() {
        let now, currentYear, years, days, months;
        now = new Date();
        currentYear = now.getFullYear();
        years = PopulateData.generateData(1920, currentYear, "desc");
        days = PopulateData.generateData(1, 31);
        months = PopulateData.generateData(0, 11);
        this.setState({
            dateOfBirthData: {
                years: years,
                months: months,
                days: days
            }
        });
    }

    handleChange = (event) => {
        const { change } = this.props;
        this.setState({ [event.target.name]: event.target.value });
        change('EditProfileForm', event.target.name, event.target.value)
    }

    handleCountryChange = (e, selectedData) => {
        const { change } = this.props;
        this.setState({
            country: selectedData.dialCode,
            countryCode: selectedData.countryCode
        });
        change('EditProfileForm', 'phoneCountryCode', selectedData.countryCode)
        change('EditProfileForm', 'dialCode', selectedData.dialCode)
    }

    handleMaxUploadFile = async () => {
        const siteData = await getSpecificConfig({ name: ['maxUploadSize'] });
        this.setState({
            maxUploadSize: siteData.maxUploadSize
        })
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { dateOfBirthData, country, countryCode } = this.state;
        const { siteSettingStatus, userId, initialValues } = this.props;
        const { isAdmin, picture } = this.props;
        let isPhoneStatus, genderValue, monthValue, daysValue, yearsValue;

        isPhoneStatus = siteSettingStatus && siteSettingStatus.phoneNumberStatus == 1 ? true : false;
        genderValue = [
            { value: '', label: formatMessage(messages.gender) },
            { value: "Male", label: formatMessage(messages.genderMale) },
            { value: "Female", label: formatMessage(messages.genderFemale) },
            { value: 'Other', label: formatMessage(messages.genderOther) }
        ]

        monthValue = [
            { value: '', label: formatMessage(messages.month) },
        ];

        daysValue = [
            { value: '', label: formatMessage(messages.transferDate) },
        ];

        yearsValue = [
            { value: '', label: formatMessage(messages.year) },
        ];


        dateOfBirthData?.months?.length > 0 && dateOfBirthData?.months?.map((item, key) => {
            monthValue.push({
                value: item,
                label: item + 1
            })
        })

        dateOfBirthData?.days?.length > 0 && dateOfBirthData?.days?.map((item, key) => {
            daysValue.push({
                value: item,
                label: item
            })
        })

        dateOfBirthData?.years?.length > 0 && dateOfBirthData?.years?.map((item, key) => {
            yearsValue.push({
                value: item,
                label: item
            })
        });

        return (
            <div className={isAdmin && s.editMainContainer}>
                {
                    isAdmin && <div className={s.userAvatarSection}>
                        <ProfileUpload
                            picture={picture}
                            userId={userId}
                            data={initialValues}
                            maxUploadSize={this.state.maxUploadSize}
                        />
                    </div>
                }
                <div className={s.displayGrid}>
                    <Field
                        name="firstName"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.firstName)}
                        placeholder={formatMessage(messages.firstName)}
                        inputClass={bt.commonControlInput}
                        infoText={formatMessage(messages.lastNameInfo)}
                        showToolTip={true}
                    />
                    <Field name="lastName"
                        type="text"
                        component={InputFieldComponent}
                        label={formatMessage(messages.lastName)}
                        placeholder={formatMessage(messages.lastName)}
                        inputClass={bt.commonControlInput}
                    />
                    <Field
                        name="gender"
                        label={formatMessage(messages.gender)}
                        inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                        component={SelectFieldComponent}
                        options={genderValue}
                    />
                    <div className={cx(s.formGroup)} >
                        <label className={cx('textWhite',bt.commonLabelText)} >{formatMessage(messages.dateOfBirth)}</label>
                        <div className={s.birthDayFlex}>
                            <Field
                                name="month"
                                inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                                component={SelectFieldComponent}
                                options={monthValue}
                            />

                            <Field
                                name="day"
                                inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                                component={SelectFieldComponent}
                                options={daysValue}
                            />

                            <Field
                                name="year"
                                inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                                component={SelectFieldComponent}
                                options={yearsValue}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className={s.displayGrid}>
                        <Field name="email"
                            type="text"
                            component={InputFieldComponent}
                            placeholder={formatMessage(messages.email)}
                            label={formatMessage(messages.email)}
                            inputClass={cx(bt.commonControlInput)}
                            disabled={true}
                        />
                        <Field name="location"
                            type="text"
                            component={InputFieldComponent}
                            label={formatMessage(messages.liveLocation)}
                            inputClass={bt.commonControlInput}
                            placeholder="e.g. Paris, France /Brooklyn, NY, IL"
                        />
                    </div>
                    <label className={cx('textWhite',bt.commonLabelText)}>{formatMessage(messages.phoneNumber)}</label>
                    <div className={s.phoneNoInputFlex}>
                        {isAdmin ? <div>
                            <CountryList
                                input={
                                    {
                                        name: 'countryCode',
                                        onChange: this.handleChange,
                                        value: countryCode,
                                    }
                                }
                                className={cx(bt.commonControlSelect, bt.space3)}
                                dialCode={false}
                                getSelected={this.handleCountryChange}
                                formName={'EditProfileInfo'}
                            />
                            <Field
                                name="phoneNumber"
                                type="text"
                                component={InputFieldComponent}
                                inputClass={cx(bt.commonControlInput,'commonControlSelectRtl')}
                                onChange={this.handleChange}
                                suffixLabel={country}
                                isAddon={true}
                            /></div> :
                            <div>
                                {!isPhoneStatus && <div className={s.widthredcd}>
                                    <CountryList
                                        input={
                                            {
                                                name: 'countryCode',
                                                onChange: this.handleChange,
                                                value: countryCode,
                                            }
                                        }
                                        className={cx(bt.commonControlSelect, bt.space3,'commonControlSelectRtl')}
                                        dialCode={false}
                                        getSelected={this.handleCountryChange}
                                        formName={'EditProfileInfo'}
                                    />
                                    <Field
                                        name="phoneNumber"
                                        type="text"
                                        component={InputFieldComponent}
                                        label={formatMessage(messages.phoneNumber)}
                                        inputClass={bt.commonControlInput}
                                        onChange={this.handleChange}
                                        suffixLabel={country}
                                        isAddon={true}
                                    />
                                </div>}
                                {
                                    isPhoneStatus ? <PhoneVerificationModal userId={userId} /> : <span></span>
                                }
                                <p className={cx(s.noMarginBottom, bt.spaceTop1)}>{formatMessage(messages.phoneNumberInfo)}</p>
                            </div>
                        }
                    </div>

                    <Field
                        name="info"
                        component={InputFieldComponent}
                        componentClass={'textarea'}
                        label={formatMessage(messages.info)}
                        inputClass={"commonTextField"}
                    />
                </div>
                <div className={bt.textEnd}>
                    <Button className={cx(bt.btnPrimary, bt.btnLarge, s.spaceTop3)} type="submit">
                        {formatMessage(messages.save)}
                    </Button>
                </div>
            </div>
        )
    }
}

const selector = formValueSelector('EditProfileInfo'); // <-- same as form name

const mapState = (state) => ({
    siteSettingStatus: state?.siteSettings?.data,
    isAdmin: state?.runtime?.isAdminAuthenticated,
    picture: selector(state, 'picture')

})

const mapDispatch = {
    change
}

export default compose(injectIntl, withStyles(s, bt), connect(mapState, mapDispatch))(CommonFields);